import React from 'react';
import { Route } from '../Routing/types';
import {
  RemoveAccountRequestIndexPage,
  RemoveAccountConfirmIndexPage,
} from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/remove-account/request',
    element: <RemoveAccountRequestIndexPage />,
    private: true,
    title: dummy_t('deletingAccount.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/remove-account/:token',
    element: <RemoveAccountConfirmIndexPage />,
    private: false,
    title: dummy_t('deletingAccount.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
];

export default routes;
